export default __webpack_public_path__ + "static/media/ca_1.c99039cd.png";